export const SQUARE_APPLICATION_ID = import.meta.env.VITE_SQUARE_APPLICATION_ID;
export const SQUARE_LOCATION_ID = import.meta.env.VITE_SQUARE_LOCATION_ID;
